<template>
<div>
    <CHead :oHead="Head"></CHead>
    <div class="row justify-content-center mt-3">
        <div class="col-12 col-md-12 col-lg-12">
			<nav>
				<div class="nav nav-tabs nav-tabs-table" id="nav-tab" role="tablist">
					<a v-for="(item,index) in Tipos" :key="index" @click="CambiarTipo(index)" :class="index==0 ? 'nav-item nav-link active' : 'nav-item nav-link'" style="width:7%" :id="item.Nombre+'-material'" data-toggle="tab" :href="'#nav-'+item.Nombre+'-material'" role="tab" :aria-controls="'#nav-'+item.Nombre+'-material'" aria-selected="true">{{item.Nombre}}</a>
				</div>
			</nav>
			<div class="tab-content tab-content-table p-0">
				<div v-for="(item,index) in Tipos" :key="index" :class="index==0 ? 'tab-pane fade show active' : 'tab-pane fade'" :id="'#nav-'+item.Nombre+'-material'" role="tabpanel" :aria-labelledby="item.Nombre+'-material'">
					<Clist :EmitSeccion="EmitSeccion" :regresar="false" :Nombre="NameList" @FiltrarC="Lista" :Filtro="Filtro" :isModal="EsModal" :pShowBtnAdd="btnadd" :ShowHead="false" :pConfigLoad="ConfigLoad" :ShowFilas=false>
						<template slot="Filtros">
							<input type="text" class="form-control mr-2 ml-2 lup" v-model="Filtro.Item" placeholder="Item..." @input="Filtrar">
							<input type="text" class="form-control mr-2 ml-2 lup" v-model="Filtro.SubItem" placeholder="SubItem..." @input="Filtrar">
							<input type="text" class="form-control mr-2 ml-2 lup" v-model="Filtro.Descripcion" placeholder="Descripción..." @input="Filtrar">
							<button v-if="ShowBotons" :disabled="DisableBtnExport" type="button" @click="ExportarExcel" class="btn btn-01 mr-2">
								<i v-show="DisableBtnExport" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
								<i v-show="!DisableBtnExport" class="fa fa-file-excel"></i> Generar Excel
							</button>
							<input :key="Filtro.Tipo+'_'+InputResetKey" v-if="ShowBotons" style="display:none" :id="'ArchivoHoja'+Filtro.Tipo" @change="SubirArchivo" type="file" :ref="'file'+Filtro.Tipo">
							<label v-if="ShowBotons" :for="'ArchivoHoja'+Filtro.Tipo" class="btn btn-primary mr-2 mt-1"><i class="fa fa-file-excel"></i> <span class="ml-1">Importar Excel</span></label>
							<span v-if="ShowBotons">{{Archivo}}</span>
							<button v-if="ShowBotons" :disabled="DisableBtnImport || Archivo == null" type="button" @click="ImportarExcel" class="btn btn-pink ml-auto">
								<i v-show="DisableBtnImport" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
								<i v-show="!DisableBtnImport" class="fa fa-file-upload"></i> Subir Archivo
							</button>
						</template>
						<template slot="header">
            		        <tr>
            		            <th>Código Empresa</th>
            		            <th>Ítem</th>
								<th>Sub Item</th>
								<th>Marca</th>
								<th>Modelo</th>
								<th>Código Fabricante</th>
								<th>Descripción</th>
								<th>Unidad</th>
								<th>Stock</th>
            		            <th>Costo Unitario</th>
								<th>Fecha Precio</th>
								<th v-if="ShowBotons">Fecha Stock</th>
            		            <th>Acciones</th>
							</tr>
            		    </template>

            		    <template slot="body">
            		        <tr v-for="(lista,index2) in ListaMaterial" :key="index2">
            		            <td v-b-tooltip.hover.top :title="lista.Codigo" width="10%">{{ $limitCharacters(lista.Codigo,20) }}</td>
								<td v-b-tooltip.hover.top :title="lista.Item" class="text-nowrap" width="8%">{{$limitCharacters(lista.Item,30) }}</td>
								<td v-b-tooltip.hover.top :title="lista.SubItem" class="text-nowrap" width="8%">{{$limitCharacters(lista.SubItem,30) }}</td>
								<td v-b-tooltip.hover.top :title="lista.Marca" class="text-nowrap" width="8%">{{$limitCharacters(lista.Marca,30) }}</td>
								<td v-b-tooltip.hover.top :title="lista.Modelo" class="text-nowrap" width="8%">{{$limitCharacters(lista.Modelo,30) }}</td>
								<td>{{lista.CodigoFabricante}}</td>
								<td v-b-tooltip.hover.top :title="lista.NomMaterial" class="text-nowrap" width="48%">{{$limitCharacters(lista.NomMaterial,110) }}</td>
								<td class="text-nowrap" width="5%">{{lista.Unidad }}</td>
								<td class="text-nowrap" width="5%">{{lista.Stock }}</td>
            		            <td class="text-nowrap" width="5%">$ {{Number(lista.Precio).toLocaleString('es-MX') }}</td>
								<td><i class="fa fa-calendar"></i> {{lista.FechaPrecio!=null ? $getCleanDate(lista.FechaPrecio,false) : 'S/F'}}</td>
								<td v-if="ShowBotons"><i class="fa fa-calendar"></i> {{lista.FechaStock!=null ? $getCleanDate(lista.FechaStock,false) : 'S/F'}}</td>
            		                <td>
										<Cbtnaccion v-if="ShowBotons" :ShowButtonG="ShowBotons" :pEmitSeccion="EmitSeccion" :isModal="EsModal" :Id="lista.IdMaterial" :IrA="FormName" >
											<!-- <template slot="btnaccion">
												<span>
													<button v-b-tooltip.hover.right title="Agregar Material" v-if="!ShowBotons" type="button" @click="Add_Material(lista)" class="btn-icon mr-2" ><i class="fa fa-plus-circle"></i></button>		
												</span>
											</template> -->
										</Cbtnaccion>
										<button v-else type="button" @click="Add_Material(lista)" class="btn-icon mr-2" ><i class="fa fa-plus-circle"></i></button>
									</td>
            		        </tr>
							<CSinRegistros :pContIF="ListaMaterial.length" :pColspan="12" ></CSinRegistros>
            		    </template>

            		</Clist>
				</div>
			</div>

            <Modal :pEmitSeccion="EmitSeccion" :NameModal="'Material'"  v-if="btnadd" :size="size" :Nombre="NameForm" :poBtnSave="oBtnSave" >
                <template slot="Form">
                <Form :pTipo="Filtro.Tipo" :NameList="NameForm"  :poBtnSave="oBtnSave" ></Form>
                </template>
            </Modal>
        </div>
    </div>
</div>

</template>
<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/modulos/almacen/materiales/Form.vue';
import CHead from "@/components/CHead.vue";
import CSinRegistros from "../../../../components/CSinRegistros";

export default {
    name :'listCotizacionConfMaterial',
    props:["pTipo"],
    components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        CHead,
		CSinRegistros
    },
    data() {
        return {
			EmitSeccion:'Material',
            FormName:'Material',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:true,//indica si es modal o no,
            CloseModal:true,//indica si el modal cierra o de lo contrario asignarle un evento al boton
            size :"modal-xl",
            NameList:"Materiales",
            NameForm:"Material",
            urlApi:"cotizacion_material/get",
            ListaMaterial:[],
            ListaHeader:[],

            Rutaicono:'',
            regresar:true,
            ShowBotons:true,
            btnadd:true,  ShowAcciones:true,
              Filtro:{
                Nombre:'',
                Placeholder:'Código Empresa..',
                 TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:'',
				SubItem:'',
				Descripcion:'',
				Tipo:'1'
            },  oBtnSave:{
				//valores  isModal(true),nombreModal('ModalForm'),tipoModal=1,regresarA(''),disableBtn(false),txtSave('Guardar'),txtCancel('Cerrar');
                isModal:true,
                disableBtn:false,
                toast:0,
				EmitSeccion:'Material',
				nombreModal:'Material',
            },
            Head: {
				ShowHead: true,
				Title: "Materiales",
				BtnNewShow: true,
				BtnNewName: "Nuevo",
				isreturn: false,
				isModal: true,
				isEmit: true,
				Url: "",
				ObjReturn: "",
				NameReturn: "Regresar",
				isCuentas: false,
				verFiltroCuentas: false,
				EmitSeccion:'Material'
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			DisableBtnExport:false,
			DisableBtnImport:false,
			MaterialesTodos:[],
			Archivo:null,
			TimeOut:'',
			errorlista:0,
			Tipos:[
				{Id:'1',Nombre:'HVAC'},
				{Id:'2',Nombre:'Refrigeracion'},
				{Id:'3',Nombre:'Electricidad'},
				{Id:'4',Nombre:'Hidrosanitario'},
				{Id:'5',Nombre:'Mecanica'},
				{Id:'6',Nombre:'Plomeria'},
				{Id:'7',Nombre:'Cocina'},
				{Id:'8',Nombre:'Contraincendios'},
			],
			InputResetKey:0
        }
    },
    methods: {
		CambiarTipo(Index){
			this.ListaMaterial=[];
			this.Filtro={
				Nombre:'',
                Placeholder:'Código Empresa..',
                TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:'',
				SubItem:'',
				Descripcion:'',
				Tipo:''
			},
			this.Filtro.Tipo=this.Tipos[Index].Id;
			this.DisableBtnExport=false;
			this.DisableBtnImport=false;
			this.Archivo=null;
			this.InputResetKey++;
			this.Lista();
		},
		async Lista() {
			this.ConfigLoad.ShowLoader = true;

			await this.$http.get(
				this.urlApi,
				{
					params:{Nombre:this.Filtro.Nombre,Entrada:this.Filtro.Entrada,pag:this.Filtro.Pagina,Item:this.Filtro.Item,RegEstatus:'A',NomMaterial:this.Filtro.Descripcion,Tipo:this.Filtro.Tipo,SubItem:this.Filtro.SubItem}
				}
			).then( (res) => {
				this.ListaMaterial =res.data.data.row;
				this.MaterialesTodos=res.data.data.todos;
				this.Filtro.Entrada=res.data.data.pagination.PageSize;
				this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});

		},
		Filtrar(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.Lista();
			},1000);
		},

        Eliminar(Id)
        {

            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {

                    this.$toast.success('Información eliminada');

                     this.$http.delete(
                            'cotizacion_material/' + Id
                        ).then( (res) => {
                                this.Lista();
                        });

                    }
                });
        },

        Change(titulo)
        {
            this.NameForm=titulo;
            var bdn=true;
            if(titulo=='Iconos'){
                bdn=false;
            }
            this.bus.$emit('cambiar_CloseModal',bdn);
        },Limpiar(){
            this.bus.$emit('cambiar_CloseModal',true);
        },Add_Material(obj){
			if (this.pTipo==2) {
				this.bus.$emit('Add_Materiales',obj);
            	$('#ModalForm').modal('hide');	
			}
			else{
				this.$swal({
                title: "Esta seguro que desea agregar este material? \n" +obj.Item,
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                	if(result.value) {
						this.bus.$emit('Add_Materiales',obj);
            			// $('#MaterialAdd').modal('hide');
                	}
                });
			}
        },
		ExportarExcel(){
			let formData=new FormData();
			formData.set('Materiales',JSON.stringify(this.MaterialesTodos));
			formData.set('Tipo',this.Filtro.Tipo);
			this.DisableBtnExport=true;
			this.$http.post('cotizacion_material/excel',formData,{
                responseType: 'blob',
            }).then((res)=>{
				let ExcelContent = res.data;
				let file = new Blob([ExcelContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let fileUrl = URL.createObjectURL(file);
				var a = document.createElement('a');
  				a.href = fileUrl;
  				a.download = 'Material_'+this.Tipos[this.Filtro.Tipo-1].Nombre;
  				document.body.append(a);
  				a.click();
  				a.remove();
  				URL.revokeObjectURL(fileUrl);
			}).finally(()=>{
				this.DisableBtnExport=false;
			});
		},
		async ImportarExcel(){
			// console.log(this.$refs.file.files[0]);
			this.errorlista=0;
			this.DisableBtnImport=true;
			let formData=new FormData();
			switch (this.Filtro.Tipo) {
				case '1':
					formData.append('Archivo',this.$refs['file1'][0].files[0]);
					break;
				case '2':
					formData.append('Archivo',this.$refs['file2'][0].files[0]);
					break;
				case '3':
					formData.append('Archivo',this.$refs['file3'][0].files[0]);
					break;
				case '4':
					formData.append('Archivo',this.$refs['file4'][0].files[0]);
					break;
				case '5':
					formData.append('Archivo',this.$refs['file5'][0].files[0]);
					break;
				case '6':
					formData.append('Archivo',this.$refs['file6'][0].files[0]);
					break;
				case '7':
					formData.append('Archivo',this.$refs['file7'][0].files[0]);
					break;
				case '8':
					formData.append('Archivo',this.$refs['file8'][0].files[0]);
					break;
				default:
					break;
			}
			formData.set('Tipo',this.Filtro.Tipo);
			await this.$http.post('cotizacion_material/excelimport',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
				this.errorlista=0;
				this.$toast.success('Los Materiales se Han Registrado Correctamente');
				// this.$refs.file.files[0]=null;
				this.DisableBtnImport=false;
			})
			.catch((err)=>{
				// console.log(err);
				this.errorlista=1;
				this.DisableBtnImport=false;
				this.$toast.warning(err.response.data.message);
				// return false;
			}).finally(()=>{
				// this.Archivo='';
				if (this.errorlista==0) {
					this.Lista();
				}
				// this.Lista();
			})
		},
		SubirArchivo(){
			// console.log(this.Filtro.Tipo);
			let image=null;
			let input=null;
			switch (this.Filtro.Tipo) {
				case '1':
					image = this.$refs['file1'][0].files[0];
					input = this.$refs['file1'][0];
					break;
				case '2':
					image = this.$refs['file2'][0].files[0];
					input = this.$refs['file2'][0];
					break;
				case '3':
					image = this.$refs['file3'][0].files[0];
					input = this.$refs['file3'][0];
					break;
				case '4':
					image = this.$refs['file4'][0].files[0];
					input = this.$refs['file4'][0];
					break;
				case '5':
					image = this.$refs['file5'][0].files[0];
					input = this.$refs['file5'][0];
					break;
				case '6':
					image = this.$refs['file6'][0].files[0];
					input = this.$refs['file6'][0];
					break;
				case '7':
					image = this.$refs['file7'][0].files[0];
					input = this.$refs['file7'][0];
					break;
				case '8':
					image = this.$refs['file8'][0].files[0];
					input = this.$refs['file8'][0];
					break;
				default:
					break;
			}
			// console.log(this.$refs);
			// const image = this.$refs.file.files[0];
			var FileSize = image.size / 1024 / 1024; // in MB
			if (FileSize > 1) {
				this.$toast.info('Solo se puede subir archivos menores a 1 MB');
				// const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
			}
			var allowedExtensions = /(\.xlsx|\.XLSX)$/i;
			if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .xlsx');
                // const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='';
                return false;
            }
			this.Archivo=image.name;
		}
    },
    created()
    {

        this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List_'+this.EmitSeccion);
        this.bus.$off('Limpiar');
        if (this.pTipo!=2 && this.pTipo!=3) {
			this.bus.$off('Regresar');
			this.bus.$on('Regresar',()=>
        	{
        	    this.$router.push({name:'almacencategoria'});
        	});
		}
        // this.Lista();

        if(this.pTipo!==undefined){
           if(this.pTipo===2 || this.pTipo===3){
                this.regresar=false;
                this.ShowBotons=false;
                this.btnadd=false;
				this.Head.ShowHead = false;
                this.bus.$emit('Cambiar_Footer',false);
           }
        }else {
			this.pTipo = 1;
		}

        this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);

        });
         this.bus.$on('List_'+this.EmitSeccion,()=>
        {
            this.Lista();
        });

        this.bus.$on('Limpiar',()=>
        {
            this.Limpiar();
        });
    },
    mounted() {
        this.Lista();
    },
}
</script>
